import * as Factory from 'factory.ts'
import faker from 'faker'

import { CurrencyNames } from '@webapp/core/entities/external/Currency'
import { type AdminCardApiModel } from '@webapp/modules/spending-cards/data-access/api-models/AdminCardApiModel'
import { CardholderAccountStatuses } from '@webapp/modules/spending-cards/entities/enums/CardholderAccountStatusEnum'
import { CardStatuses } from '@webapp/modules/spending-cards/entities/enums/CardStatusEnum'
import { CardTypes } from '@webapp/modules/spending-cards/entities/enums/CardTypeEnum'
import { IssuingProviders } from '@webapp/modules/spending-cards/entities/enums/IssuingProvider'

export const AdminCardApiModelStub =
  Factory.Sync.makeFactory<AdminCardApiModel>({
    id: Factory.each(() => faker.random.number()),
    external_id: Factory.each(() => faker.random.uuid()),
    cardholder: Factory.each(() => ({
      id: faker.random.number(),
      external_id: faker.random.uuid(),
      user_id: faker.random.number(),
      first_name: faker.name.firstName(),
      last_name: faker.name.lastName(),
      email: faker.internet.email(),
      department_id: faker.random.number(),
      profile_image: '',
      tos_accepted: true,
      provider: IssuingProviders.AIRWALLEX,
      status: CardholderAccountStatuses.ACTIVE,
    })),
    number: Factory.each(() => faker.finance.mask(4, false, false)),
    created_at: Factory.each(() => faker.date.past().toISOString()),
    updated_at: Factory.each(() => faker.date.past().toISOString()),
    status: CardStatuses.ACTIVE,
    balance: Factory.each(() => faker.random.number().toString()),
    currency: CurrencyNames.USD,
    category: Factory.each(() =>
      faker.random.arrayElement(Object.values(CardTypes))
    ),
    require_activation: false,
    shipping_address: Factory.each(() => ({
      name: faker.name.firstName(),
      address_line_one: faker.address.streetAddress(),
      address_line_two: null,
      postal_code: faker.address.zipCode(),
      city: faker.address.city(),
      state_province: faker.address.state(),
      country: faker.address.country(),
    })),
    expiry_date: Factory.each(() => faker.date.future().toISOString()),
    name: Factory.each(() => faker.name.firstName()),
  })
